import {
    mdiAccountArrowRightOutline,
    mdiAccountOutline,
    mdiAccountSupervisorOutline,
    mdiCartOutline,
    mdiClipboardListOutline,
    mdiDoctor,
    mdiHandHeartOutline,
    mdiHospitalBoxOutline,
    mdiMedicalBag,
    mdiScissorsCutting,
    mdiStethoscope,
} from '@mdi/js';
import _ from 'lodash';
import { ProviderType } from '../../api';
import { generateLabel, withNpi } from './util';

const providerTypeLabels: Record<string, string> = {
    [ProviderType.BILLING]: 'Billing Provider',
    [ProviderType.RENDERING]: 'Rendering Provider',
    [ProviderType.ATTENDING]: 'Attending Provider',
    [ProviderType.REFERRING]: 'Referring Provider',
    [ProviderType.SUPERVISING]: 'Supervising Provider',
    [ProviderType.ORDERING]: 'Ordering Provider',
    [ProviderType.OPERATING]: 'Operating Provider',
    [ProviderType.TREATING]: 'Treating Provider',
    [ProviderType.PURCHASING]: 'Purchasing Provider',
};

const providerTypeIcons: Record<string, string> = {
    [ProviderType.BILLING]: mdiMedicalBag,
    [ProviderType.RENDERING]: mdiStethoscope,
    [ProviderType.ATTENDING]: mdiDoctor,
    [ProviderType.REFERRING]: mdiAccountArrowRightOutline,
    [ProviderType.SUPERVISING]: mdiAccountSupervisorOutline,
    [ProviderType.ORDERING]: mdiClipboardListOutline,
    [ProviderType.OPERATING]: mdiScissorsCutting,
    [ProviderType.TREATING]: mdiHandHeartOutline,
    [ProviderType.PURCHASING]: mdiCartOutline,
};

export const getProviderTypeLabel = (type?: string): string => {
    if (!type) {
        return 'Provider';
    }

    const normalizedType = type.toUpperCase();
    return providerTypeLabels[normalizedType] || `${_.startCase(_.toLower(type))} Provider`;
};

export const getProviderTypeIcon = (type?: string): string => {
    if (!type) {
        return mdiAccountOutline;
    }

    return providerTypeIcons[type.toUpperCase()] || mdiAccountOutline;
};

export const getProviderBadgeLabel = (
    type?: string,
    id?: string,
    name?: string,
    organization?: string,
    npi?: string,
): string => withNpi(generateLabel(getProviderTypeLabel(type), id, name || organization), npi);
